// extracted by mini-css-extract-plugin
module.exports = {"menu":"ApplicationMenu_menu__Odnle"};